import { render, staticRenderFns } from "./EmptyTransactionNotification.vue?vue&type=template&id=f0100e46&"
import script from "./EmptyTransactionNotification.vue?vue&type=script&lang=js&"
export * from "./EmptyTransactionNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports